<template>
  <h3><span style="font-weight: 200"> 'Communicating Science Visually'</span></h3>
  <h4>Thursday, March 14, 2019 &mdash; EMBL, Heidelberg</h4>
  <p>
    The 2019 VIZBI Art &amp; Biology Evening featured a keynote by
    <a href="https://biochem.web.utah.edu/iwasa/" target="_blank">Janet Iwasa</a>
    (The University of Utah, Salt Lake City, USA) on
    <em>Communicating science visually</em>. Janet is a biomedical animator whose work bridges the
    gap between scientific research and visual communication, helping scientists and the public
    understand complex biological processes through compelling animation and illustration.
  </p>
  <HeroImage hero-image="/Showcase/2019.jpg" />
  <p>
    The evening began with welcome drinks in the ATC Foyer, followed by Janet's keynote address and
    an Art &amp; Biology Showcase, before the VIZBI conference dinner. The session was chaired by
    <a href="https://www.linkedin.com/in/christianstolte" target="_blank">Christian Stolte</a>
    (The New York Genome Center).
  </p>
</template>

<script setup>
import HeroImage from "@/components/HeroImage.vue";
</script>

<style scoped>
h3 {
  display: inline;
}
h4 {
  font-weight: 600;
  font-size: 1rem;
  margin-top: 0.3rem;
}
img {
  float: right;
  margin: 0 0 1rem 1.5rem;
  height: clamp(100px, 20vw, 180px);
  width: auto;
  border-radius: 4px;
}
</style>
